"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OktonSearchSelect = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const lu_1 = require("react-icons/lu");
const OktonSearchSelect = ({ name, options, value, onChange, search, onSearchChange, placeholder = 'Selecione', loading = false, emptyMessage = 'Nenhum resultado', allowFreeText = false, minWidth, isDisabled = false, autoComplete = 'off', filterOptions = true, }) => {
    var _a;
    const [open, setOpen] = react_2.default.useState(false);
    const [internalSearch, setInternalSearch] = react_2.default.useState('');
    const container = react_2.default.useRef(null);
    const bg = (0, react_1.useColorModeValue)('white', 'gray.700');
    const hoverBg = (0, react_1.useColorModeValue)('gray.100', 'gray.600');
    const color = (0, react_1.useColorModeValue)('gray.700', 'white');
    const border = (0, react_1.useColorModeValue)('gray.200', 'gray.600');
    (0, react_1.useOutsideClick)({
        ref: container,
        handler: () => setOpen(false),
    });
    const actualSearch = search !== undefined ? search : internalSearch;
    function setSearch(next) {
        if (onSearchChange)
            onSearchChange(next);
        else
            setInternalSearch(next);
    }
    const selected = options.find(option => option.value === value);
    const normalizedSearch = actualSearch
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLocaleLowerCase('pt-BR')
        .trim();
    const visibleOptions = react_2.default.useMemo(() => {
        if (!filterOptions || normalizedSearch === '')
            return options;
        return options.filter(option => option.label
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLocaleLowerCase('pt-BR')
            .includes(normalizedSearch));
    }, [options, filterOptions, normalizedSearch]);
    const displayText = open
        ? actualSearch
        : (_a = selected === null || selected === void 0 ? void 0 : selected.label) !== null && _a !== void 0 ? _a : (allowFreeText ? actualSearch : '');
    function choose(option) {
        if (option.disabled)
            return;
        onChange(option.value);
        setSearch(option.label);
        setOpen(false);
    }
    function clear() {
        onChange('');
        setSearch('');
        setOpen(false);
    }
    return (react_2.default.createElement(react_1.Box, { position: "relative", ref: container, minW: minWidth, w: "100%" },
        react_2.default.createElement(react_1.Input, { id: name, name: name, color: color, size: "lg", rounded: "xl", fontWeight: "light", autoComplete: autoComplete, placeholder: placeholder, value: displayText, isDisabled: isDisabled, pr: loading ? '20' : '16', onFocus: () => {
                setSearch(allowFreeText || !selected
                    ? actualSearch
                    : '');
                setOpen(true);
            }, onChange: event => {
                setSearch(event.target.value);
                setOpen(true);
                if (value)
                    onChange('');
            } }),
        react_2.default.createElement(react_1.Box, { position: "absolute", right: "4", top: "50%", transform: "translateY(-50%)", display: "flex", alignItems: "center", gap: "1", color: "gray.400", pointerEvents: isDisabled ? 'none' : undefined },
            loading ? react_2.default.createElement(react_1.Spinner, { size: "xs" }) : null,
            (value || actualSearch) ? (react_2.default.createElement(react_1.Box, { as: "button", type: "button", "aria-label": "Limpar", onClick: clear, display: "flex" }, react_2.default.createElement(lu_1.LuX, { size: 16 }))) : null,
            react_2.default.createElement(lu_1.LuChevronDown, { size: 18 })),
        open && !isDisabled ? (react_2.default.createElement(react_1.List, { position: "absolute", zIndex: 20, mt: "1", w: "100%", maxH: "220px", overflowY: "auto", bg: bg, borderWidth: "1px", borderColor: border, rounded: "xl", boxShadow: "lg" }, visibleOptions.length === 0 ? (react_2.default.createElement(react_1.ListItem, { px: "4", py: "2" },
            react_2.default.createElement(react_1.Text, { fontSize: "sm", color: "gray.500" }, loading ? 'Buscando...' : emptyMessage))) : (visibleOptions.map(option => (react_2.default.createElement(react_1.ListItem, { key: option.value, px: "4", py: "2", cursor: option.disabled ? 'not-allowed' : 'pointer', opacity: option.disabled ? 0.6 : 1, color: color, fontSize: "sm", bg: option.value === value ? hoverBg : undefined, _hover: option.disabled ? undefined : { bg: hoverBg }, onMouseDown: () => choose(option) }, option.label)))))) : null));
};
exports.OktonSearchSelect = OktonSearchSelect;
//# sourceMappingURL=OktonSearchSelect.js.map